import type { ApplyEffectContext } from "./effectContext.js";

export function startInn(ctx: ApplyEffectContext): ApplyEffectContext {
  if (ctx.run.hand.length === 0) return ctx;
  return {
    ...ctx,
    run: {
      ...ctx.run,
      pendingChoice: {
        kind: "inn",
        sourceInstanceId: ctx.sourceInstanceId,
        selected: [],
      },
    },
  };
}
